<template>
  <section class="home container">
    <h2 class="title">Benvenuto</h2>
    <p class="subtitle">
      Per poter utilizzare l'applicazione è necessario effettuare
      <router-link :to="{name: 'Login'}">l'accesso</router-link>.
    </p>
  </section>
</template>

<script>
  export default {
    name: 'Home'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue